export const FETCH_AR_EMPLOYEE_UPDATE_SUCCESS =
  'FETCH_AR_EMPLOYEE_UPDATE_SUCCESS';
export const FETCH_AR_EMPLOYEE_API_FAILURE = 'FETCH_AR_EMPLOYEE_API_FAILURE';
